import * as z from "zod/v4";

export const connectToIntegration = {
  name: "connectToIntegration" as const,
  input: z.object({
    integrationId: z.string(),
    connectionId: z.string(),
    inputValues: z.record(z.string(), z.any()).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    redirectUrl: z.string().optional(),
    message: z.string().optional(),
  }),
};
